import React from "react";
export default function CardCreditOption(props) {
  if (props.isBlue) {
    return (
      <div
        className={
          "w-[100%] h-[30%] md:h-[17vh]  bg-white rounded-[15px] shadow-xl  flex flex-col justify-center  items-center self-center border-[#00C6CA] border-[1px] "
        }
      >
        <img
          className="object-center object-contain h-16 m-4 "
          src={props.img}
          alt=""
        />
        <div className="w-full px-1 justify-center text-black font-montserrat text-base mb-2 font-medium text-center mt-0">
          {props.title}
        </div>
      </div>
    );
  } else
    return (
      <div
        className={
          "w-[100%] h-[30%] bg-white rounded-[15px] shadow-xl p-4 flex flex-col justify-center  items-center mt-4 mb-4  self-center border-transparent"
        }
      >
        <img
          className="object-center object-contain w-20 h-20 md:w-[70px] md:h-[73.39px]"
          src={props.img}
          alt=""
        />
        <div className=" text-black font-montserrat text-base font-semibold text-center mt-2">
          {props.title}
        </div>
      </div>
    );
}
